import { useParams } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
  Box,
  ModalProvider,
  PaginationProvider,
  SearchProvider,
  SortProvider,
  BulkActionsProvider,
  Spinner,
  UpgradeSubscriptionModalType,
  FilterProvider,
  DropdownOptions,
  TooltipPopup,
} from 'dash-ui';

import { useGetPortfolioFolderByIdQuery } from 'gql/generated.graphql';
import RemovePropertyFromPortfolio from 'containers/portfolio/RemovePropertyFromPortfolio/RemovePropertyFromPortfolio';
import RemoveFolderFromPortfolio from 'containers/portfolio/RemoveFolderFromPortfolio/RemoveFolderFromPortfolio';
import MovePropertyToFolderModal from 'containers/portfolio/MovePropertyToFolderModal/MovePropertyToFolderModal';
import PropertyComparisonModal from 'containers/portfolio/PropertyComparisonModal/PropertyComparisonModal';
import SharePortfolioModal from 'containers/portfolio/SharePortfolioModal/SharePortfolioModal';
import UpgradeSubscriptionModal from 'common/components/UpgradeSubscriptionModal/UpgradeSubscriptionModal';
import { useBrowserTabTitle } from 'common/hooks/use-browser-tab-title/use-browser-tab-title';

import PortfoliosPageTopBar from './components/PortfolioDetailTopBar/PortfolioDetailTopBar';
import PortfolioDetailView from './components/PortfolioDetailView/PortfolioDetailView';
import { SubscriptionChangeConfirmationModal } from 'pages/ProfilePage/components/ProfileBilling/components';
import ManageMediaKitModal from 'containers/portfolio/ManageMediaKitModal/ManageMediaKitModal';

const PortfolioDetailsPage = () => {
  const { id = '' } = useParams();
  const theme = useTheme();
  const { t } = useTranslation();
  const { data, loading } = useGetPortfolioFolderByIdQuery({
    variables: {
      portfolioFolderId: id,
    },
  });

  const portfolio = data?.getPortfolioFolderById;

  useBrowserTabTitle(
    `${portfolio?.name || t('common:labels.loading')} ${t(
      `common:labels.dashSuffix`
    )}`
  );

  return (
    <PaginationProvider>
      <SortProvider>
        <FilterProvider>
          <SearchProvider>
            <ModalProvider>
              <BulkActionsProvider>
                <DropdownOptions />
                <TooltipPopup />
                <Box w="100%" minHeight={150} pos="relative">
                  {portfolio && (
                    <>
                      <PortfoliosPageTopBar portfolio={portfolio} />
                      <PortfolioDetailView portfolio={portfolio} />
                    </>
                  )}
                  {loading && (
                    <Spinner fullContent bgColor={theme.colors.n20} size={32} />
                  )}
                  <RemoveFolderFromPortfolio />
                  <RemovePropertyFromPortfolio />
                  <MovePropertyToFolderModal />
                  <PropertyComparisonModal />
                  <SharePortfolioModal />
                  <ManageMediaKitModal />
                  <SubscriptionChangeConfirmationModal />
                  <UpgradeSubscriptionModal
                    type={UpgradeSubscriptionModalType.PORTFOLIO}
                  />
                </Box>
              </BulkActionsProvider>
            </ModalProvider>
          </SearchProvider>
        </FilterProvider>
      </SortProvider>
    </PaginationProvider>
  );
};

export default PortfolioDetailsPage;
